import { render, staticRenderFns } from "./SelectClassPop.vue?vue&type=template&id=bafd1d34&"
import script from "./SelectClassPop.vue?vue&type=script&lang=js&"
export * from "./SelectClassPop.vue?vue&type=script&lang=js&"
import style0 from "./SelectClassPop.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports